'use strict';

var base58 = require('bs58');
var y = require('yup');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var base58__default = /*#__PURE__*/_interopDefaultCompat(base58);
var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'tron';
const TRON_ERROR = 'tron';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? TRON_ERROR
        },
        test: (value)=>{
            if (value == null) {
                return false;
            }
            try {
                const decodedTRX = base58__default.default.decode(value);
                // Remove last four checksum bytes.
                const len = decodedTRX.length;
                const offset = len - 4;
                const sliced = decodedTRX.slice(0, offset);
                return sliced.length === 21 && Buffer.from(sliced).toString('hex').startsWith('41');
            } catch  {
                return false;
            }
        }
    });
});

exports.TRON_ERROR = TRON_ERROR;
//# sourceMappingURL=tron.js.map
